import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import router from '../router';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: () => ({
    jsonData: null,
    currentFloorIndex: 0,
    currentRoomIndex: null,
    currentExhibit: null,

    mediaPlayer: {
      isActive: false,
      images: null,
      audio: null,
      audioActive: false,
      gallery: null,
      galleryItem: null,
      progress: 0,
      description: null,
    },

    imageZoomed: false,

    darkmodeActive: false,

    currentColor: 'hsl(212, 60%, 33%)',

    backgroundPattern: '',

    infoActive: false,
  }),
  mutations: {
    setJsonData: (state, data) => {
      state.jsonData = data;
    },

    setFloorIndex: (state, floorIndex) => {
      state.currentFloorIndex = floorIndex;
    },
    setRoomIndex: (state, roomIndex) => {
      state.currentRoomIndex = roomIndex;
    },
    setCurrentExhibit: (state, exhibitObject) => {
      state.currentExhibit = exhibitObject;
    },

    setPlayerAudio: (state, audioObject) => {
      state.mediaPlayer.audio = audioObject;
    },
    setPlayerGallery: (state, galleryObject) => {
      state.mediaPlayer.gallery = galleryObject;
    },
    setPlayerGalleryItem: (state, itemObject) => {
      state.mediaPlayer.galleryItem = itemObject;
    },
    setPlayerImages: (state, imageArray) => {
      state.mediaPlayer.images = imageArray;
    },
    setPlayerDescription: (state, text) => {
      state.mediaPlayer.description = text;
    },
    setPlayerActive: (state, playerState) => {
      state.mediaPlayer.isActive = playerState;
    },
    setPlayerAudioActive: (state, playstate) => {
      state.mediaPlayer.audioActive = playstate;
    },

    setImageZoomed: (state, activestate) => {
      state.imageZoomed = activestate;
    },
    setDarkmodeActive: (state, activestate) => {
      state.darkmodeActive = activestate;
    },
    setCurrentColor: (state, color) => {
      state.currentColor = color;
      document.querySelector('meta[name="theme-color"]').setAttribute('content', color);
      // document.body.style.backgroundColor = color;
      document.documentElement.style.setProperty('--theme-color', color);
    },

    setBackgroundPattern: (state, dataURI) => {
      state.backgroundPattern = dataURI;
    },

    setInfoActive: (state, activestate) => {
      state.infoActive = activestate;
    },
  },
  actions: {
    async fetchJsonData({ commit }) {
      if (process.env.VUE_APP_DEBUG === 'on') console.log(`fetch JSON from:${process.env.VUE_APP_JSON_FILE_PATH}`);
      try {
        await fetch(process.env.VUE_APP_JSON_FILE_PATH).then((response) => response.json())
          .then((data) => {
            commit('setJsonData', data);
            if (process.env.VUE_APP_DEBUG === 'on') console.log('JSON loaded.');
          });
      } catch (error) {
        console.error(error);
      }
    },

    setFloorIndex({ commit }, floorIndex) {
      commit('setFloorIndex', floorIndex);
      commit('setCurrentColor', this.state.jsonData.floors[this.state.currentFloorIndex].color);

      commit('setRoomIndex', null);
      // router.push({ path: `/${this.state.currentFloorIndex}` });

      if (process.env.VUE_APP_DEBUG === 'on') console.log(`setFloorIndex: ${this.state.currentFloorIndex}`);
    },
    setRoomIndex({ commit }, roomIndex) {
      commit('setRoomIndex', roomIndex);
      if (roomIndex !== null) {
        // router.push({ path: `/${this.state.currentFloorIndex}/${this.state.currentRoomIndex}` });
        commit('setCurrentColor', this.state.jsonData.floors[this.state.currentFloorIndex].rooms[this.state.currentRoomIndex].color);
      } else {
        // router.push({ path: `/${this.state.currentFloorIndex}` });
        commit('setCurrentColor', this.state.jsonData.floors[this.state.currentFloorIndex].color);
      }

      if (process.env.VUE_APP_DEBUG === 'on') console.log(`setRoomIndex: ${this.state.currentRoomIndex}`);
    },
    setExhibit({ commit }, exhibitObject) {
      commit('setCurrentExhibit', exhibitObject);

      if (exhibitObject !== null) {
        /* router.push({ path: `/${this.state.currentFloorIndex}/
         ${this.state.currentRoomIndex}/${this.state.currentExhibit.id}` }); */
      } else {
        // router.push({ path: `/${this.state.currentFloorIndex}/${this.state.currentRoomIndex}` });
      }

      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log('setCurrentExhibit');
        // console.log(this.state.currentExhibit);
      }
    },

    setPlayerAudio({ commit }, audioObject) {
      commit('setPlayerAudio', audioObject);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log('setPlayerAudio');
        // console.log(this.state.currentPlayerAudio);
      }
    },
    setPlayerGallery({ commit }, galleryObject) {
      commit('setPlayerGallery', galleryObject);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log('setPlayerGallery');
      }
    },
    setPlayerGalleryItem({ commit }, itemObject) {
      commit('setPlayerGalleryItem', itemObject);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log('setPlayerGalleryItem');
      }
    },
    setPlayerImages({ commit }, imageObject) {
      commit('setPlayerImages', imageObject);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log('setPlayerImages');
        // console.log(this.state.currentPlayerImages);
      }
    },
    setPlayerDescription({ commit }, text) {
      commit('setPlayerDescription', text);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log('setPlayerDescription');
        // console.log(this.state.currentPlayerDescription);
      }
    },
    setPlayerActive({ commit }, playerState) {
      commit('setPlayerActive', playerState);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log(`setPlayerActive: ${playerState}`);
        // console.log(this.state.currentPlayerAudio);
      }
    },
    setPlayerAudioActive({ commit }, playstate) {
      commit('setPlayerAudioActive', playstate);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log(`setPlayerAudioActive: ${playstate}`);
        // console.log(this.state.currentPlayerAudio);
      }
    },

    setColor({ commit }, colorString) {
      commit('setCurrentColor', colorString);
      if (process.env.VUE_APP_DEBUG === 'on') console.log(`setCurrentColor: ${this.state.currentColor}`);
    },

    setImageZoomed({ commit }, activestate) {
      commit('setImageZoomed', activestate);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log(`setImageZoomed: ${activestate}`);
      }
    },
    setDarkmodeActive({ commit }, activestate) {
      commit('setDarkmodeActive', activestate);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log(`setDarkmodeActive: ${activestate}`);
      }
    },
    setBackgroundPattern({ commit }, dataURI) {
      commit('setBackgroundPattern', dataURI);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log('setBackgroundPattern');
      }
    },

    setInfoActive({ commit }, activestate) {
      commit('setInfoActive', activestate);
      if (process.env.VUE_APP_DEBUG === 'on') {
        console.log(`setInfoActive: ${activestate}`);
      }
    },

    resetNavigation({ commit }) {
      commit('setRoomIndex', null);
      commit('setCurrentExhibit', null);
      commit('setPlayerAudio', null);
      commit('setCurrentColor', this.state.jsonData.floors[this.state.currentFloorIndex].color);

      commit('setImageZoomed', false);
      commit('setInfoActive', false);
      commit('setPlayerGallery', null);

      if (router.currentRoute.path.length > 2) {
        router.push({ path: `/${this.state.currentFloorIndex}` });
      }

      if (process.env.VUE_APP_DEBUG === 'on') console.log('reset navigation');
    },
    resetData({ commit }) {
      commit('setRoomIndex', null);
      commit('setCurrentExhibit', null);
      commit('setCurrentColor', this.state.jsonData.floors[this.state.currentFloorIndex].color);

      commit('setPlayerImages', null);
      commit('setPlayerAudio', null);
      commit('setPlayerAudioActive', false);
      commit('setPlayerGalleryItem', null);
      commit('setPlayerGallery', null);
      commit('setPlayerActive', false);

      commit('setImageZoomed', false);
      commit('setInfoActive', false);
      if (process.env.VUE_APP_DEBUG === 'on') console.log('reset data');
    },
  },
  getters: {
    jsonData: (state) => state.jsonData,

    currentFloorIndex: (state) => state.currentFloorIndex,
    currentRoomIndex: (state) => state.currentRoomIndex,
    currentExhibit: (state) => state.currentExhibit,

    currentPlayerAudio: (state) => state.mediaPlayer.audio,
    currentPlayerGallery: (state) => state.mediaPlayer.gallery,
    currentGalleryItem: (state) => state.mediaPlayer.galleryItem,
    currentPlayerImages: (state) => state.mediaPlayer.images,
    currentPlayerDescription: (state) => state.mediaPlayer.description,
    playerActive: (state) => state.mediaPlayer.isActive,
    playerAudioActive: (state) => state.mediaPlayer.audioActive,

    currentColor: (state) => state.currentColor,

    imageZoomed: (state) => state.imageZoomed,
    darkmodeActive: (state) => state.darkmodeActive,

    backgroundPattern: (state) => state.backgroundPattern,

    infoActive: (state) => state.infoActive,

    // Get only
    currentRoomTitle:
      (state) => state.jsonData.floors[state.currentFloorIndex].rooms[state.currentRoomIndex].title,
    floorsLength:
      (state) => state.jsonData.floors.length,
  },
  modules: {
  },
});
